import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentEventObject: {},
};

const currentSlice = createSlice({
  name: 'currentAppointmentSlice',
  initialState,
  reducers: {
    setReduxCurrentEventObject: (state, action) => {
      state.currentEventObject = action?.payload;
    },
  },
});

export const { setReduxCurrentEventObject } = currentSlice.actions;
export default currentSlice.reducer;
